import { setExperimentsContext } from '@adv-frontend/yastore-modules/lib';
import { tryParseJSON } from '@adv-frontend/yastore-modules/lib';
import {
    setRequestContext,
    setStoreInfoRequestContext,
    setStoreProgramContext,
    setStoresRequestContext,
    setUserRequestContext,
} from '#shared/lib/context';
import {
    EXPERIMENTS_CONTEXT_ID,
    REQUEST_CONTEXT_ID,
    STORE_INFO_REQUEST_CONTEXT_ID,
    STORE_PROGRAM_CONTEXT_ID,
    STORES_REQUEST_CONTEXT_ID,
    USER_REQUEST_CONTEXT_ID,
} from './const';

function processing<T>(htmlSelector: string, setContextFn: (value: T) => void) {
    const contextElement = document.querySelector(htmlSelector);
    const contextJSON = contextElement?.innerHTML ? tryParseJSON(contextElement.innerHTML) : {};

    setContextFn(contextJSON as T);

    // Оставляем контекст в браузере для debug
    if (__IS_DEV__) {
        return;
    }

    contextElement?.remove();
}

export function init() {
    processing(`#${REQUEST_CONTEXT_ID}`, setRequestContext);
    processing(`#${USER_REQUEST_CONTEXT_ID}`, setUserRequestContext);
    processing(`#${STORE_INFO_REQUEST_CONTEXT_ID}`, setStoreInfoRequestContext);
    processing(`#${STORES_REQUEST_CONTEXT_ID}`, setStoresRequestContext);
    processing(`#${STORE_PROGRAM_CONTEXT_ID}`, setStoreProgramContext);
    processing(`#${EXPERIMENTS_CONTEXT_ID}`, setExperimentsContext);
}
